import API from '@/services/http'

export const getWebSoketMsgById = (wsMsgId: string) =>
  API.admin.post<{ success: boolean; payload: string }>('/oneclub-api/api/message/get_websocket_msg', {
    wsMsgId,
  })

export interface RiskResultBo {
  eventCode?: string
  source?: string
  countryCode?: string
  serialNo?: string
  hitPunishType?: string
  hitPunish?: string
  hitRiskTypes?: string[]
  hitBusinessTags?: string[]
}
export interface UserExportFileResponse {
  url?: string
  riskResult?: RiskResultBo
}

export const file = (data: { taskId: string }, headers = {}) => {
  return API.admin.post<UserExportFileResponse>('/api/order/export/file', data, { ...headers })
}
